<div class="c-card">
    <div class="c-card__header">
        <ng-content select="medpace-card-header"></ng-content>
    </div>
    <div class="c-card__content">
        <ng-content select="medpace-card-content"></ng-content>
    </div>
</div>
